// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FT6T","colBig":"styles_colBig__1AImH","colSmall":"styles_colSmall__pFysk","shopifyNameWrapper":"styles_shopifyNameWrapper__V5eYO"};